<template>
    <div>
        <Wp_nav_bar title="重置密码"></Wp_nav_bar>

        <div style="padding: 20px">
            <div class="regist_input_div">
                <van-field
                        class="regist_input"
                        label-width="70px"
                        v-model="user_name"
                        label="用户名"
                        placeholder="请输入用户名"
                        required
                        clearable
                ></van-field>
            </div>

            <div class="regist_input_div">
                <van-field
                        class="regist_input"
                        label-width="70px"
                        v-model="phone_number"
                        type="tel"
                        label="手机号"
                        placeholder="请输入绑定的手机号"
                        required
                        clearable
                ></van-field>
            </div>

            <div class="regist_input_div">
                <van-row>
                    <van-col span="18" >
                        <van-field
                                class="regist_input"
                                label-width="70px"
                                v-model="verify_code"
                                type="number"
                                label="验证码"
                                placeholder="请输入验证码"
                                required
                        ></van-field>
                    </van-col>
                    <van-col span="6"
                             style="text-align: right;height: 50px; margin-top: -2px; margin-bottom: -2px;">
                        <van-button class="code_button" type="danger" plain @click="getVerifyCode" :disabled="get_verify_button_status"
                        >
                            {{get_verify_button_name}}
                        </van-button>
                    </van-col>
                </van-row>

            </div>

            <van-button style="margin-top: 10%; border-radius:4px" @click="checkAndUpdate" type="danger" size="large"
                        :disabled="update_button_status" :loading="loading_status"
                        :loading-text="loading_text">
                重置密码
            </van-button>
        </div>

    </div>
</template>

<script>
    import Wp_nav_bar from "../custom/Wp_nav_bar";
    export default {
        name: "Wp_reset_password",
        components: {Wp_nav_bar},
        data(){
            return{
                user_name: '',
                phone_number: '',
                verify_code: '',

                //修改按钮状态
                update_button_status: false,
                loading_status: false,
                loading_text: "处理中...",

                //获取验证码按钮状态
                get_verify_button_status: false,

                get_verify_button_name: "获取验证码",

                time_limit: 60,

                time_tmp: 60,

            }
        },

        created(){
            // //判断是否弹出登录界面
            // let isLogin = this.$store.getters.isLogin;
            // this.$log("isLogin = " + isLogin);
            // if(isLogin!==true) {
            //     this.$bus.$emit('toLogin', '登录吧,牛宝宝');
            //
            //     window.location.replace("/index.html");
            // }

        },

        methods:{

            timeDown(){
                this.get_verify_button_name = this.time_tmp + "秒后可重新获取"

                if(this.time_tmp >= 0){
                    setTimeout(()=>{
                        this.time_tmp--;
                        this.timeDown();
                    }, 1000)
                }else{
                    this.get_verify_button_status = false;
                    this.get_verify_button_name = "获取验证码";
                    this.time_tmp = this.time_limit;
                }
            },

            /**
             * 校验验证码，校验成功直接修改
             */
            checkAndUpdate() {
                let phoneNumber = this.phone_number;
                let verifyCode = this.verify_code;
                let user_name = this.user_name;
                if (user_name && phoneNumber && verifyCode && this.$common.isPoneAvailable(phoneNumber)) {

                    let params = {
                        phone: phoneNumber,
                        code: verifyCode,
                    };

                    //点击"注册"后，将按钮置为不可用
                    this.update_button_status = true;
                    this.loading_status = true;

                    this.$checkPhoneVerifyCode(params, response => {
                        this.$log(response)
                        // {code: 200, message: "验证码正确,通过验证"}
                        if (response.code === 200) {
                            //验证通过,重置密码
                            this.resetPassword();
                        }else{
                            this.$dialog.alert({
                                message: response.message
                            });
                        }

                        this.update_button_status = false;
                        this.loading_status = false;
                    })
                } else {
                    this.$dialog.alert({
                        message: "请输入正确的用户名、绑定手机号码和验证码"
                    });
                }
            },

            resetPassword(){
                let params = {
                    uid: this.user_name,
                    phone: this.phone_number,
                };

                this.$resetPassword(params, response =>{
                    this.$log(response)
                    if(response && response.code === 200){
                        this.$dialog.alert({
                            title: response.msg,
                            message: "重置初始密码为：" + response.u_pwd + "\n\n为了账户安全，请登录后立即修改密码"
                        }).then(()=>{
                            if(this.$config.project === 'mini'){
                                this.$common.navigateBack();
                            }

                            this.onClickBack();
                        })
                    }else{
                        this.$dialog.alert({
                            message: response.msg
                        })
                    }

                })
            },

            /**
             * 获取验证码
             */
            getVerifyCode() {
                let phoneNumber = this.phone_number;
                if (phoneNumber && this.$common.isPoneAvailable(phoneNumber)) {
                    let params = {
                        phone: phoneNumber,
                    };

                    this.get_verify_button_status = true;

                    // this.timeDown();

                    this.$getPhoneVerifyCode(params, response => {
                        this.$log(response)
                        // {code: 200, message: "验证码发送成功"}
                        if (response.code === 200) {
                            //获取到验证码
                            //启动倒计时
                            this.timeDown();
                        } else if (response.code > 200) {
                            this.get_verify_button_status = false;
                            this.$dialog.alert({
                                message: response.message
                            });
                        }
                    });
                } else {
                    this.$dialog.alert({
                        message: "请输入正确的手机号码"
                    });
                }
            },
        }
    }
</script>

<style scoped>
    .regist_input_div {
        margin-top: 5%;
        padding: 2px;
        border-radius: 4px;
        border: 1px solid #E52212
    }

    .regist_input {
        font-size: 16px
    }

    .code_button {
        height: 50px;
        width: auto;
        /*border-left: 2px solid red;*/
        /*border-right: 0px;*/
        /*border-top: 0px;*/
        /*border-bottom: 0px;*/
        border: 0px;
        /*border-radius: 0px;*/
        padding: 0px;
        /*padding-right: 5px;*/
        /*text-align: right;*/
        position: absolute;
        /*background-color: #aaaaaa;*/
        right: 30px;
    }

    .success_data_div {
        /*border: 1px solid #77FFCC55;*/
        border: 1px solid #E52212;
        border-radius: 4px;
        padding: 10px;
        /*background-color: #77FFCC22;*/
        background-color: #03FFF211;
        font-size: 17px;
        line-height: 32px;
    }

    .tip_div {
        margin-top: 20px;
        border: 1px solid #03FFF255;
        border-radius: 4px;
        padding: 10px;
        background-color: #03FFF222;
        font-size: 15px;
        line-height: 25px;
    }
</style>